import Entity from "../../../class/abstract/Entity";
import User from "../../_auth/Users/User";
import DevelopmentRequestController from "./DevelopmentRequestController";

class DevelopmentRequest extends Entity {
    number = null;
    title = null;
    message = null;
    created_by = null;
    creator = null;
    creatorName = null;
    state = null;
    stateName = null;
    rejectedReason = null;

    constructor(datas = {}) {
        super(datas);
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        let keys = Object.keys(this);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined) {
                if (key === "creator") Reflect.set(this, key, new User(datas[key]));
                else Reflect.set(this, key, datas[key]);
            }
        }

		if (this.state !== null)
			this.stateName = DevelopmentRequestController._states[this.state];

		if (this.creator !== null)
			this.creatorName = this.creator.fullName();
    }
}

export default DevelopmentRequest;
